// src/icons/index.js

// استيراد جميع الأيقونات من lucide-react
import {
  Home,
  Mail,
  Users,
  Map,
  ShoppingCart,
  BarChart2,
  LogOut,
  ChevronDown,
  ChevronUp,
  UserCheck,
  MapPin,
  Briefcase,
  Clock,
  CheckCircle,
  Tag,
  Heart,
  Bell,
  Shield,
  Send,
  CreditCard,
  Menu,
  X,
  Search,
  BookOpen,
  Filter,
  Building,
  LandPlot,
  FileText,
  MessageCircle,
  Settings,
  // يمكنك إضافة المزيد هنا
} from 'lucide-react';

import {
  FiCalendar,
  FiClock,
  FiMapPin,
  FiUser,
  FiVideo,
  FiFilter,
  FiChevronRight,
  FiChevronLeft,
  FiExternalLink,
  FiSearch,
  FiSlash,
  FiCheck,
  FiX,
  FiRefreshCw,
  FiEye,
  FiEdit,
  FiCopy,

  FiMail,
  FiPhone,
  FiHome,
 
  FiMessageSquare,
  
  FiNavigation,
  FiTarget,
  FiImage,
  /////
    FiMap,
  
    FiFileText,
   
    FiLayers,
    FiUsers,
    FiGitPullRequest,
    FiBriefcase,
    FiAward,
    FiInfo,
} from "react-icons/fi";
// تصدير كائن يحتوي على جميع الأيقونات
const Icons = {
  Home,
  Mail,
  Users,
  Map,
  ShoppingCart,
  BarChart2,
  LogOut,
  ChevronDown,
  ChevronUp,
  UserCheck,
  MapPin,
  Briefcase,
  Clock,
  CheckCircle,
  Tag,
  Heart,
  Bell,
  Shield,
  Send,
  CreditCard,
  Menu,
  X,
  Search,
  BookOpen,
  Filter,
  Building,
  LandPlot,
  FileText,
  MessageCircle,
  Settings,
   FiCalendar,
  FiClock,
  FiMapPin,
  FiUser,
  FiVideo,
  FiFilter,
  FiChevronRight,
  FiChevronLeft,
  FiExternalLink,
  FiSearch,
  FiSlash,
  FiCheck,
  FiX,
  FiRefreshCw,
  FiEye,
  FiEdit,
  FiCopy,
   FiMail,
  FiPhone,
  FiHome,
 
  FiMessageSquare,
  
  FiNavigation,
  FiTarget,
  FiImage,
  FiMap,
  
    FiFileText,
   
    FiLayers,
    FiUsers,
    FiGitPullRequest,
    FiBriefcase,
    FiAward,
    FiInfo,
};

// تصدير افتراضي
export default Icons;

// تصدير الأيقونات بشكل منفصل أيضاً
export {
  Home,
  Mail,
  Users,
  Map,
  ShoppingCart,
  BarChart2,
  LogOut,
  ChevronDown,
  ChevronUp,
  UserCheck,
  MapPin,
  Briefcase,
  Clock,
  CheckCircle,
  Tag,
  Heart,
  Bell,
  Shield,
  Send,
  CreditCard,
  Menu,
  X,
  Search,
  BookOpen,
  Filter,
  Building,
  LandPlot,
  FileText,
  MessageCircle,
  Settings,
  FiCalendar,
  FiClock,
  FiMapPin,
  FiUser,
  FiVideo,
  FiFilter,
  FiChevronRight,
  FiChevronLeft,
  FiExternalLink,
  FiSearch,
  FiSlash,
  FiCheck,
  FiX,
  FiRefreshCw,
  FiEye,
  FiEdit,
  FiCopy,
   FiMail,
  FiPhone,
  FiHome,
 
  FiMessageSquare,
  
  FiNavigation,
  FiTarget,
  FiImage,
  FiMap,
  
    FiFileText,
   
    FiLayers,
    FiUsers,
    FiGitPullRequest,
    FiBriefcase,
    FiAward,
    FiInfo,
};
